<script lang="ts">
	import Breadcrumb from '../../components/Breadcrumb.svelte';
	import { onMount } from 'svelte';
	import { detectClickOutside } from '$lib/utils/detectClickOutside';
	export let data;
	let selected = '';
	import arrow from '$lib/images/volba-skutru/arrow.png';
	import { scooterStorage } from '../../stores/preferences';
	import ScooterSelectorNavigation from '../(components)/ScooterSelectorNavigation.svelte';
	import BrandList from "$lib/components/general/BrandList.svelte";
	let showList = false;
	let filtered: any[] = [];
	let filterText = '';

	filtered = data.producers;

	let elm: any;

	onMount(function () {
		elm.focus();
		showList = true;

		scooterStorage.set({
			url: '',
			producer: '',
			name: '',
			model: '',
			hasArticles: false,
			hasGraphs: false,
			ccm: 0,
			image: '',
		});
	});

	// create filter function on producers
	function filterProducer(text: string) {
		showList = true;
		filtered = data.producers.filter((item: any) =>
			item.producer.toLowerCase().startsWith(text.toLowerCase())
		);
	}

	const handleClickOutside = () => {
		showList = false;
	};
</script>

<svelte:head>
	<title>Skútry všech výrobců</title>
	<meta name="description" content="Vyberte model skútru od výrobce {data?.producersList}"/>
	<link rel="canonical" href={`https://www.scootland.cz/skutry/`} />
    <meta property="og:title" content="Skútry všech výrobců" />
	<meta property="og:description" content="Vyberte model skútru od výrobce {data?.producersList}"/>
	<meta property="og:image" content="/image/og-skutry.webp"/>
	<meta property="og:url" content="https://www.scootland.cz/skutry/"/>
	<meta property="og:suite_name" content="Scootland"/>
    <meta property="og:type" content="website" />
</svelte:head>


<Breadcrumb breadcrumbs={[{ name: 'Skútry', link: '/skutry/'}]} />

<section class="bg-graybg py-8">
	<div class="mx-auto w-full px-2 md:w-4/6 lg:px-0">
		<div class="container mx-auto">
			<div class="border-b border-gray-200">
				<h1 class="mb-6 pb-4 text-center text-2xl font-bold sm:text-3xl">
					Skútry - vyberte výrobce a model
				</h1>
			</div>
		</div>

		<ScooterSelectorNavigation step={1} />

		<div class="w-full">
			<div class="relative mb-[350px]">
				<input
					type="text"
					focused
					use:detectClickOutside
					on:click_outside={handleClickOutside}
					bind:this={elm}
					placeholder="Vyberte výrobce"
					bind:value={filterText}
					on:input={filterProducer(filterText)}
					on:click={() => (showList = true)}
					class="form-select px-4.5 border-primary focus:border-blue-600 m-0 block w-full appearance-none border-4 border-solid bg-white bg-clip-padding bg-no-repeat py-3.5 text-left indent-8 text-gray-700 transition ease-in-out focus:bg-white focus:text-gray-700 focus:outline-none"
				/>
				<div
					data-test="producers_list"
					class="{showList ? '' : 'hidden'} test focus:border-focusblue absolute w-full
       overflow-y-auto border-4 bg-white bg-clip-padding bg-clip-padding bg-no-repeat text-gray-700
      transition ease-in-out focus:bg-white focus:text-gray-700 focus:outline-none"
					style="max-height: 350px;"
				>
					{#if filtered.length > 0}
						{#each filtered as item}
							<a rel="prerender"
								id={item}
								href="/skutry/{item.lowerText}/"
								class="w-100 flex cursor-pointer p-2 pl-5 transition hover:bg-gray-100"
							>
								{item.producer}
							</a>
						{/each}
					{/if}
				</div>
			</div>
		</div>
	</div>
</section>

<section class="shadow-top bg-white pt-8">
	<h2 class="mb-6 px-5 pb-4 text-center text-xl font-bold">
		Raději obrázky? Zkuste to podle loga níže!
		<img src={arrow} class="ml-2 inline-block" alt="šipka na výběr skútru" />
	</h2>
</section>

<BrandList brands={data.producers} />
